export const locale = {
  lang: 'en',
  data: {
    CONFIRM: 'Confirm',
    OK: 'OK',
    CANCEL: 'Cancel'
  }
};
